import React from 'react'
import Grid from '@material-ui/core/Grid'
import { makeStyles } from '@material-ui/core/styles'
import { useTheme } from '@material-ui/core'
import { CLOUDINARY_NAME } from '../../../constants'
import { Image, Transformation } from 'cloudinary-react'
import { Link } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
    inThePressHeading: {
        textTransform: 'uppercase',
        textAlign: 'center',
        fontSize: '1.2rem',
        letterSpacing: 1.5,
        marginTop: 10,
        marginBottom: 10,
        [theme.breakpoints.up('md')]: {
            marginTop: '2.5rem',
            marginBottom: 0,
        },
    },
    pressLogos: {
        padding: '0 1rem',
        justifyContent: 'space-between',
        alignItems: 'center',
        textAlign: 'left',
        '& img': {
            maxHeight: '100px',
            maxWidth: '100%',
        },
        [theme.breakpoints.up('md')]: {
            padding: '0 3rem',
        },
    },
    inline: {
        display: 'inline !important',
    },
    lazyLoaded: {
        opacity: 1,
        transition: 'opacity 300ms',
    },
    gridItem: {
        width: '17%',
        maxWidth: '17%',
        textAlign: 'center',
        marginRight: '1rem',
    },
}))

const pressImages = [
    {
        cloudinaryId: 'GCG/legit_page/abc-news_vc6hgc',
        alt: 'ABC News',
        url: 'https://abcnews.go.com/US/video/tips-tricks-minute-holiday-shopping-81904729',
        hideOnMobile: true,
        sm: 4,
        md: 3,
        testId: 'abc-news-logo-link',
    },
    {
        cloudinaryId: 'GCG/legit_page/cbs-newyork_amzbsw',
        alt: 'CBS New York',
        url: 'https://www.cbsnews.com/newyork/news/coronavirus-pandemic-means-a-different-kind-of-mothers-day-celebration/',
        hideOnMobile: true,
        sm: 4,
        md: 3,
        testId: 'cbs-newyork-logo-link',
    },
    {
        cloudinaryId: 'GCG/legit_page/cheddar_nw4uci',
        alt: 'Cheddar',
        url: 'https://cheddar.com/media/how-to-avoid-coronavirus-scams',
        hideOnMobile: true,
        sm: 4,
        md: 3,
        testId: 'cheddar-logo-link',
    },
    {
        cloudinaryId: 'GCG/legit_page/nbc-news_zdgchc',
        alt: 'NBC News',
        url: 'https://www.nbcnews.com/business/consumer/retailers-are-making-it-easier-you-return-gifts-buy-more-n702561',
        hideOnMobile: true,
        sm: 4,
        md: 3,
        testId: 'nbc-news-logo-link',
    },
    {
        cloudinaryId: 'GCG/legit_page/cnbs_k0eogj',
        alt: 'CNBS',
        url: 'https://www.cnbc.com/2016/11/23/gift-card-exchanges-can-save-you-up-to-35-percent.html',
        hideOnMobile: true,
        sm: 4,
        md: 3,
        testId: 'cnbs-logo-link',
    },
    {
        cloudinaryId: 'GCG/legit_page/forbes_flybvh',
        alt: 'Forbes',
        url: 'https://www.forbes.com/sites/zackfriedman/2017/01/10/gift-cards-cash/?sh=230371bb5943',
        hideOnMobile: true,
        sm: 4,
        md: 3,
        testId: 'forbes-logo-link',
    },
    {
        cloudinaryId: 'GCG/legit_page/good-morning-america_mxekqz',
        alt: 'Good Morning America',
        url: 'https://www.goodmorningamerica.com/living/story/top-tips-make-holiday-returns-breeze-score-deeper-60016667',
        hideOnMobile: true,
        sm: 4,
        md: 3,
        testId: 'good-morning-america-logo-link',
    },
    {
        cloudinaryId: 'GCG/legit_page/oprah_kltxcb',
        alt: 'The Oprah Magazine',
        url: 'https://www.oprah.com/money/4-ways-to-get-a-bigger-shopping-discount',
        hideOnMobile: true,
        sm: 4,
        md: 3,
        testId: 'oprah-magazine-logo-link',
    },
    {
        cloudinaryId: 'GCG/legit_page/us-news_oer6fw',
        alt: 'US News',
        url: 'https://money.usnews.com/money/personal-finance/saving-and-budgeting/articles/throwing-a-baby-shower-on-a-budget',
        hideOnMobile: true,
        sm: 4,
        md: 3,
        testId: 'us-news-logo-link',
    },
    {
        cloudinaryId: 'GCG/legit_page/wgn-america_gje3n2',
        alt: 'WGN America',
        url: 'https://wgntv.com/midday-news/midday-fix-tips-to-save-you-money-on-back-to-school-shopping/',
        hideOnMobile: true,
        sm: 4,
        md: 3,
        testId: 'wgn-america-logo-link',
    },
]

const InThePressSection = () => {
    const classes = useStyles()
    const theme = useTheme()
    return (
        <>
            <Grid container className={`${classes.pressLogos}`}>
                {pressImages.map((pressImage, index) => {
                    return (
                        <Grid
                            item
                            sm={pressImage.sm}
                            md={pressImage.md}
                            className={classes.gridItem}
                            key={index}
                        >
                            <Link
                                href={pressImage.url}
                                rel={'noopener noreferrer'}
                                target={'_blank'}
                                data-testid={pressImage.testId}
                            >
                                <Image
                                    cloudName={CLOUDINARY_NAME}
                                    publicId={pressImage.cloudinaryId}
                                    className={`${classes.inline} ${classes.lazyLoaded}`}
                                    alt={pressImage.alt}
                                    loading="lazy"
                                >
                                    <Transformation
                                        width="auto"
                                        crop="scale"
                                        fetchFormat="auto"
                                    />
                                </Image>
                            </Link>
                        </Grid>
                    )
                })}
            </Grid>
        </>
    )
}

export default InThePressSection
